<template>
  <div class="base-box">
    <van-field v-model="params.mobile" class="input-item" label="手机号" placeholder="请输入您的手机号码"></van-field>
    <van-field class="input-item" v-model="params.captcha" label="图片验证" clearable placeholder="请输入图片验证码">
      <div slot="button" @click="changeCode()">
        <img v-if="captchaImage" :src="captchaImage" class="chaImage" />
      </div>
    </van-field>
    <van-field class="input-item" v-model="params.code" label="验证码" placeholder="请输入短信验证码">
      <van-button slot="button" size="small" type="primary" @click="getCode">
        <template v-if="!isSpend">获取验证码</template>
        <template v-else>( {{ time }} )</template>
      </van-button>
    </van-field>
    <van-button class="nextBtn" type="primary" size="large" @click="submit">下一步</van-button>
  </div>
</template>

<script>
  import { Field, Button, Toast, Icon } from "vant";
  import {
    getRegisterCode,
    checkMobile,
    verifyRegisterCode,
    fastRegisterMember,
    getCaptchaImage
  } from "@/api/login";

  export default {
    data() {
      return {
        isSpend: false,
        time: 60,
        params: {
          mobile: "",
          code: "",
          captcha: ""
        },
        captchaImage: null,
      };
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Icon.name]: Icon,
      [Toast.name]: Toast,

    },
    created() {
      this.getCaptchaImageFunction()
    },
    methods: {
      changeCode() {
        this.getCaptchaImageFunction()
      },

      getCaptchaImageFunction() {
        let captchaUuid = "";
        if (sessionStorage.getItem("captchaUuid")) {
          captchaUuid = sessionStorage.getItem("captchaUuid");
        } else {
          //生成captchaUuid
          let times = new Date().getTime();
          let numNo = Number(Math.random().toString().substr(2));
          captchaUuid = (times + numNo).toString(12);
          sessionStorage.setItem("captchaUuid", captchaUuid);
        }
        getCaptchaImage({ captchaUuid: captchaUuid }).then(res => {
          if (res.success) {
            this.$set(this, "captchaImage", res.result)
          } else {
            this.$message.error(res.message || "验证码生成失败");
          }
        })
      },
      async getCode() {
        let mobile = this.params.mobile;

        if (this.isSpend) {
          return;
        }

        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号！");
          return false;
        }
        if (!this.params.captcha) {
          Toast("请输入图片验证码");
          return false;
        }
        await this.checkMobiles(mobile);
        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getRegisterCode({
          mobile: mobile,
          captchaUuid: sessionStorage.getItem("captchaUuid"),
          captcha: this.params.captcha, sign: sign, timestamp: timestamp
        }).then((res) => {
          if (res.success) {
            this.isSpend = true;
            this.time = 60;
            this.count();
          } else {
            Toast(res.message)
          }
        });
      },
      checkMobiles(mobile) {
        let params = {
          mobile,
        };

        return new Promise((resolve) => {
          checkMobile(params).then((res) => {
            if (!res.result && res.success) {
              Toast("该手机号码还未注册！");
            } else {
              resolve();
            }
          });
        });
      },
      count() {
        --this.time;
        if (this.time > 0) {
          setTimeout(() => {
            this.count();
          }, 1000);
        } else {
          this.isSpend = false;
        }
      },
      submit() {
        let value = this.value;
        let isMobile = this.$regexp.mobile(this.params.mobile);
        let code = { code: this.params.code };
        if (!this.params.mobile || !isMobile) {
          Toast("请输入正确的手机号码！");
          return;
        }
        if (!this.params.captcha) {
          Toast("请输入图形验证码！");
          return;
        }

        if (!this.params.code) {
          Toast("请输入验证码！");
          return;
        }

        verifyRegisterCode(this.params).then((res) => {
          if (res.success) {
            this.$emit("success", this.params.mobile);
          } else {
            Toast.fail("验证码不正确！");
          }
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .input-item {
    padding: 0;
    padding-bottom: 12px;
    display: flex;
    align-items: center;

    i {
      color: #aaa;
    }

    &+.input-item {
      margin-top: 20px;
    }
  }

  /deep/.van-field__label {
    width: 2.2rem;
  }

  .successedBtn {
    margin: 30px 0 25px 0 !important;
  }

  .rule-box {
    justify-content: center;
    margin-bottom: 20px;
  }

  .nextBtn {
    margin-top: 60px;
  }

  .type_box {
    overflow: hidden;
    border-bottom: #dfdfdf solid 1px;
    margin-bottom: 30px;
    margin-top: -10px;
  }

  .type_box p {
    float: left;
    font-size: 15px;
    height: 50px;
    line-height: 50px;
    color: #333;
  }

  /deep/.van-field__label {
    width: 2.2rem
  }

  .chaImage {
    width: 90px;
    height: 30px;
    margin-left: 10px
  }
</style>